import { useContext } from 'react';
import { store } from '../store';
import { usePostRequest } from '../../core/coreUseRequest';

/** useDeletePayment ::  {} */
export default function useDeletePayment() {
	const { dispatch } = useContext(store);

	return usePostRequest({
		url: '/pay/client/delete/payment',
		queryName: 'getClientInvoices',
		dispatch,
		successFn: () =>
			dispatch({
				type: 'close dialog'
			})
	});
}
